
export default class ImageHolder {
  constructor(type) {
    this.base64 = null;
    this.public_id = null;
    this.comment = '';
  }
}
